import { Link } from "react-router-dom";

const MenuContainers = (dropdownRef, closeDropdownMenu) => {
  const links = [
    {
      displayName: "Hinged (Duo Front Tab)",
      linkTo: "/products/hingedduo",
    },
    {
      displayName: "Hinged (Center Slide)",
      linkTo: "/products/centerslide",
    },
    {
      displayName: "Deli Containers",
      linkTo: "/products/deli",
    },
    {
      displayName: "Portion Cups",
      linkTo: "/products/portion",
    },
    {
      displayName: "Round Containers",
      linkTo: "/products/round",
    },
    {
      displayName: "Noodle Bowls",
      linkTo: "/products/noodle",
    },
    {
      displayName: "Rectangular Containers",
      linkTo: "/products/rectangular",
    },
    {
      displayName: "Compartmental Containers",
      linkTo: "/products/compartment",
    },
    {
      displayName: "Cold Cups",
      linkTo: "/products/coldcup",
    },
    {
      displayName: "Hot Cups",
      linkTo: "/products/hotcup",
    },
  ];

  return (
    <ul ref={dropdownRef}>
      {links.map((link, index) => {
        return (
          <li className="px-4 py-2 hover:bg-containx-beige">
            <Link
              to={link.linkTo}
              onClick={closeDropdownMenu}
              className="block"
              key={"container-menu-" + index}
            >
              {link.displayName}
            </Link>
          </li>
        );
      })}
      <li className="px-4 py-2 hover:bg-containx-beige font-bold">
        <Link to="/products" onClick={closeDropdownMenu} className="block">
          See All
        </Link>
      </li>
    </ul>
  );
};

export default MenuContainers;
